import { buildPaginationQueryParamSchema } from '@guiker/api-definition'
import { yup } from '@guiker/yup-util'

export const searchListingQuerySchema = buildPaginationQueryParamSchema().shape({
  includeAssets: yup.boolean().default(true),
})
